const titleCase = (value: string) =>
  value
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ")

export const formatDeviceType = (type?: string | null) => {
  if (!type) return "Unknown"

  const normalized = type.trim()
  if (!normalized) return "Unknown"

  const compact = normalized.toLowerCase().replace(/[^a-z0-9]/g, "")
  if (compact.includes("lwm2m")) return "LwM2M"
  if (compact.includes("mqtt")) return "MQTT"
  if (compact.includes("smartmeter")) return "Smart Meter"
  if (compact.includes("datalogger")) return "Data Logger"
  if (compact === "unknown") return "Unknown"

  const cleaned = normalized
    .replace(/c8y/gi, "")
    .replace(/devices?/gi, "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()

  return cleaned ? titleCase(cleaned) : "Unknown"
}
